module.exports = __webpack_public_path__ + "@/assets/img/045-boy-20.b22fd6af.svg";